import { getState } from './state';
import { InitializationStatus } from '../../types';
function getInitializationStoreSlice(state) {
    var _getState_initialization;
    return (_getState_initialization = getState(state).initialization) !== null && _getState_initialization !== void 0 ? _getState_initialization : {};
}
export function getIsReduxInitialized(state) {
    return getInitializationStoreSlice(state).isReduxInitialized === InitializationStatus.Success;
}
export function getInitializationStatus(state) {
    const initializationStoreSlice = getInitializationStoreSlice(state);
    const initializationStatuses = Object.values(initializationStoreSlice);
    if (initializationStatuses.length === 0 || initializationStatuses.includes(InitializationStatus.Initializing)) {
        return InitializationStatus.Initializing;
    } else if (initializationStatuses.includes(InitializationStatus.Failure)) {
        return InitializationStatus.Failure;
    }
    return InitializationStatus.Success;
}
